import { PERMISSIONS } from "@/constants";

export default [
  {
    name: "financing",
    meta: {
      title: "Financing - Businesses",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL]
    },
    path: "/financing/businesses",
    component: () => import("@/views/pages/financing"),
  },
  {
    name: "financing-analytics",
    meta: {
      title: "Financing - Analytics Dashboard",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/analytics",
    component: () => import("@/views/pages/financing/AnalyticsDashboard.vue"),
  },
  {
    name: "financing-requests",
    meta: {
      title: "Financing - All Requests",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/requests/:business_id?",
    component: () => import("@/views/pages/financing/FinancingRequests.vue"),
  },
  {
    name: "business-insights",
    meta: {
      title: "Business Insights",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/business/:business_id/insights",
    component: () => import("@/views/pages/financing/BusinessInsights.vue"),
  },
  {
    name: "eligible-customers",
    meta: {
      title: "Eligible Customers",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/eligible-customers",
    component: () => import("@/views/pages/financing/EligibleCustomers.vue"),
  },
  {
    name: "upcoming-repayments",
    meta: {
      title: "Upcoming Repayments",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/repayments",
    component: () => import("@/views/pages/financing/UpcomingRepayments.vue"),
  },
  {
    name: "zand-payment",
    meta: {
      title: "Zand Bank Payment",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/payment/:requestId",
    component: () => import("@/views/pages/financing/ZandPayment.vue"),
  },
  {
    name: "financing-settings",
    meta: {
      title: "Financing Settings",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/settings/:business_id",
    component: () => import("@/views/pages/financing/FinancingSettings.vue"),
  },
  {
    name: "financing-rules",
    meta: {
      title: "Financing - Rules",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/rules",
    component: () => import("@/views/pages/financing/Rules.vue"),
  },
  {
    name: "financing-breach-silence-approval",
    meta: {
      title: "Financing - Approve Silence",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/breaches/:breachId/silence",
    component: () => import("@/views/pages/financing/SilenceApproval.vue"),
  },
  {
    name: "financing-breaches",
    meta: {
      title: "Financing - Breaches",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/breaches",
    component: () => import("@/views/pages/financing/Breaches.vue"),
  },
  {
    name: "financing-invoices",
    meta: {
      title: "Financing - Invoices",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.FINANCING_ALL],
    },
    path: "/financing/invoices",
    component: () => import("@/views/pages/financing/Invoices.vue"),
  },
]; 